import { createFileRoute, Navigate } from '@tanstack/react-router'
import { z } from 'zod'
import { zodValidator, fallback } from '@tanstack/zod-adapter'
import { GovernanceLayout } from '@/components/governance/governance-layout'
import { AuditLogList } from '@/components/governance/audit-log-list'
import { usePermissions } from '@/lib/hooks/use-permissions'

const auditLogSearchSchema = z.object({
  event_type: fallback(z.string(), '').default(''),
  object_type: fallback(z.string(), '').default(''),
  actor_id: fallback(z.string(), '').default(''),
  from: fallback(z.string(), '').default(''),
  to: fallback(z.string(), '').default(''),
  page: fallback(z.number(), 1).default(1),
  page_size: fallback(z.number(), 20).default(20),
})

export type AuditLogSearch = z.infer<typeof auditLogSearchSchema>

export const Route = createFileRoute('/_authenticated/governance/audit-logs')({
  validateSearch: zodValidator(auditLogSearchSchema),
  component: GovernanceAuditLogsPage,
})

function GovernanceAuditLogsPage() {
  const { canViewApprovals, canViewAuditLogs, isLoading } = usePermissions()

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
      </div>
    )
  }

  if (!canViewAuditLogs && canViewApprovals) {
    return <Navigate to="/governance" />
  }

  if (!canViewAuditLogs && !canViewApprovals) {
    return <Navigate to="/" />
  }

  return (
    <GovernanceLayout activeTab="audit-logs">
      <AuditLogList />
    </GovernanceLayout>
  )
}
